import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import TableBodyCheckbox from '../../../../components/Table/BodyCheck';
import Dropdown from '../../../../components/Dropdown/Default';

import { generateTableBody, getItemActions } from '../../helpers';
import { useTbodyPosition } from '../../../../utils/hooks/useTbodyPosition';

const Body = ({ isLoading, items, config, values, handleSelect, onChangeCheck }) => {
  const bodyRef = useRef(null);
  const position = useTbodyPosition({ bodyRef, count: items?.length, bodyHeight: '300px' });

  return (
    <tbody
      className={classNames('', { 'tbody-loading': isLoading })}
      style={{ backgroundPositionY: position.y, backgroundPositionX: position.x }}
      ref={bodyRef}
    >
      {items?.map((item) => (
        <tr key={item.id} className={values.includes(item.id) ? 'active' : ''}>
          {generateTableBody(item, config?.access)?.map((element, idx) => {
            switch (element.type) {
            case 'checkbox':
              return (
                <TableBodyCheckbox
                  key={idx}
                  tdClass="check"
                  disabled={item?.status !== 1}
                  item={item}
                  values={values}
                  onChangeCheck={onChangeCheck}
                />
              );

            case 'service':
              return (
                <td key={element.type} className={element.class} {...element.attrs}>
                  {item.service_id !== 0 && <span className="service__id">{item.service_id}</span>}
                  {element.value}
                </td>
              );

            case 'runs':
              return (
                <td key={element.type} className={element.class} {...element.attrs}>
                  {item.runs_current !== 0 && item.runs_link ? (
                    <Link to={item.runs_link?.replace('/admin', '')}>{item.runs_current}</Link>
                  ) : (
                    item.runs_current
                  )}
                  {' '}
                  /
                  {' '}
                  {element.value}
                </td>
              );

            case 'actions':
              const itemActions = getItemActions(item, config?.access);
              if (!itemActions?.length) {
                return (
                  <td key={element.type} className={element.class} {...element.attrs}>
                    {' '}
                  </td>
                );
              }
              return (
                <td key={element.type} className={element.class} {...element.attrs}>
                  <Dropdown
                    handleSelect={(key, title) => handleSelect({ key, title, item }, 'single')}
                    size="xsmall"
                    title="Actions"
                    items={itemActions}
                    forMassActions
                    classForBtnDrop="font__weight-med"
                    dropStyle="default"
                    toolbarClass="dropdown-right"
                    id={item.id}
                    item={item}
                  />
                </td>
              );

            default:
              return (
                <td key={element.type} className={element.class} {...element.attrs}>
                  {element?.value}
                </td>
              );
            }
          })}
        </tr>
      ))}
    </tbody>
  );
};

Body.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  config: PropTypes.object,
  values: PropTypes.array,
  handleSelect: PropTypes.func,
  onChangeCheck: PropTypes.func,
};

export default Body;
